module.exports = __webpack_public_path__ + "pc/img/swiper_bg_01.34bc4e5f.png";